<template>
  <div
    v-if="client && settings"
    id="content"
    :class="
      tv_mode && tv_mode_scroll
        ? 'h-screen overflow-hidden bg-truegray-100'
        : ''
    "
  >
    <!-- 
      ================================ 
      *** ARE WE  ON THE CLOUD : client === 'client1cloud' ???
      ================================ 
    -->
    <CWCloudMenu v-if="client === 'client1cloud'" />

    <!-- Client 1 Menu -->
    <CWCentralMenu v-if="client === 'client1'" />

    <!-- Client2 & Tenant2 Expo Main Menu -->
    <ExpoMainMenu
      v-if="
        client === 'client2cloud' ||
        client === 'client2' ||
        client === 'client2tenant'
      "
      :class="client === 'client2tenant' ? 'hidden xl:block' : ''"
    />

    <!-- Tenant 2 Menu Mobile -->
    <div
      v-if="window.width < 1280 && client === 'client2tenant'"
      class="w-screen fixed top-0 z-50"
    >
      <ExpoTenantMenuMobile />
    </div>

    <!-- TV Mode -->
    <div
      v-if="client === 'client1tenant' && tv_mode"
      class="w-full h-16 bg-cw-900 flex items-center px-6 fixed top-0 left-0 z-50"
    >
      <img
        class="h-10 absolute left-6 top-3"
        src="/img/cw-tv-logo-white.png"
        alt="CareerWise logo"
      />
      <h1 class="text-xl text-white text-center mb-0 text-center w-full">
        Latest posts from the {{ settings.profile_title }} CareerWise settings
      </h1>
    </div>

    <!-- TV Mode Video -->
    <div
      v-if="tv_mode"
      id="cwtv_video_wrapper"
      class="fixed top-0 left-0 z-60 pointer-events-none w-screen h-screen transition-all bg-black"
    >
      <video
        id="cwtv_video"
        class="lg:object-fit w-full h-full"
        preload="auto"
        playsinline=""
        loop=""
        muted=""
      >
        <source src="/img/cw_tv.mp4" type="video/mp4" />
      </video>
    </div>

    <!-- Content -->
    <div class="w-100 relative cw_content" :class="baseContentClasses">
      <!-- Contributor Dashboard Menu -->
      <CWCDMenu v-if="isPortalContext($route)" class="w-56 fixed" />

      <!-- Tenant 1 Smart Menu -->
      <div
        v-if="client === 'client1tenant' && !tv_mode"
        :class="!showSmartMenu ? 'opacity-0 pointer-events-none' : ''"
        class="transition-all duration-300"
      >
        <CWTenantMenuSmart />
      </div>

      <!-- Tenant 1 Layout 0 Menu Desktop -->
      <div
        v-if="
          window.width >= 1024 &&
          client === 'client1tenant' &&
          customisation.layout === 0 &&
          customisation.menu === 0 &&
          !tv_mode
        "
        :class="[
          template === 'Home' ? 'menu_homepage' : 'h-screen',
          'w-56 fixed left-0 top-0 z-50',
        ]"
      >
        <CWTenantLayout0Menu />
      </div>

      <!-- Tenant 1 Layout 0 Compact Menu Desktop -->
      <div
        v-if="
          window.width >= 1024 &&
          client === 'client1tenant' &&
          customisation.layout === 0 &&
          customisation.menu === 1 &&
          !tv_mode
        "
        :class="[
          template === 'Home' ? 'menu_homepage' : 'h-screen',
          'w-16 fixed left-0 top-0 z-50',
        ]"
      >
        <CWTenantLayout0MenuCompact :homepage="template" />
      </div>

      <!-- Tenant 1 Layout 1 Compact Menu Desktop && global mobile menu -->
      <div
        v-if="
          ((client === 'client1tenant' &&
            customisation.layout === 1 &&
            customisation.menu === 1) ||
            (client === 'client1tenant' && window.width < 1024)) &&
          !tv_mode
        "
        class="w-full fixed left-0 top-0 z-50"
      >
        <CWTenantLayout1MenuCompact :homepage="template" />
      </div>

      <!-- Tenant 1 Layout 1 Menu Desktop -->
      <div
        v-if="
          client === 'client1tenant' &&
          customisation.layout === 1 &&
          customisation.menu === 0 &&
          window.width >= 1024 &&
          !tv_mode
        "
        class="w-full fixed left-0 top-0 z-50"
      >
        <CWTenantLayout1Menu />
      </div>

      <!-- Tenant 1 layout 2 Menu Desktop -->
      <div
        v-if="
          client === 'client1tenant' &&
          customisation.layout === 2 &&
          window.width >= 1024 &&
          !tv_mode
        "
        class="w-full fixed left-0 top-0 z-50"
      >
        <CWTenantLayout2Menu />
      </div>

      <!-- Tenant 2 Menu Desktop -->
      <div
        v-if="window.width >= 1280 && client === 'client2tenant'"
        class="h-screen w-56 fixed left-0 top-0 z-70"
      >
        <ExpoTenantMenu />
      </div>

      <!-- ROUTER TEMPLATE -->
      <!-- @TODO make computed properties and possibly add layout 1 considerations. Layout 1 doesnt have a margin. 32 is the height of the menu -->
      <router-view
        :class="
          client === 'client1tenant' &&
          customisation.layout === 2 &&
          window.width >= 1024 &&
          !tv_mode
            ? 'mt-32'
            : ''
        "
      />
      <!-- /ROUTER TEMPLATE -->

      <!-- Expo Global Sidebar for-schools / for-exhibitors -->
      <div
        v-if="
          window.width >= 1024 &&
          (client === 'client2tenant' ||
            client === 'client2' ||
            client === 'client2cloud')
        "
        :class="'h-screen w-44 fixed right-0 top-0 z-50'"
      >
        <ExpoGlobalMenu :client="client" />
      </div>
    </div>

    <!-- Footer bar -->
    <div
      v-if="client === 'client1tenant' && !tv_mode"
      :class="template === 'Homepage' ? 'lg:fixed lg:bottom-0' : ''"
      class="relative z-60 w-full"
    >
      <CWTenantFooter />
    </div>

    <!-- Expo central footer -->
    <div v-if="client === 'client1'" class="relative z-60 w-full">
      <CWCentralFooter />
    </div>

    <!-- Expo tenant footer -->
    <div v-if="client === 'client2tenant'" class="relative w-full">
      <ExpoTenantFooter />
    </div>

    <!-- Expo central footer -->
    <div
      v-if="client === 'client2' || client === 'client2cloud'"
      class="relative z-60 w-full"
    >
      <ExpoCentralFooter />
    </div>

    <!-- Show Expo Main menu navigation -->
    <div v-if="showExpoMenuContent" class="relative z-90">
      <ExpoMainMenuContent />
    </div>

    <!--  
      ************ 
      UNIVERSAL MODAL  
      ************ 
    -->
    <div
      v-if="showModal"
      id="showModal"
      class="fixed z-70 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <!--
          Modal panel, show/hide based on modal state.
          @todo - more neatly refactor width into each modal component instead of showModal style
        -->
        <div
          :class="[
            showModalContents ? 'translate-y-0' : 'translate-y-full opacity-0',
            showModal === 'logout' ? 'bg-transparent' : 'bg-white',
            {
              'w-full lg:min-w-2xl sm:max-w-3xl sm:w-full':
                !modalData?.dynamicWidth,
            },
          ]"
          :style="[
            showModal === 'editor-link-modal' ||
            showModal === 'cw-upsert-admin' ||
            showModal === 'cw-contributor-upsert-account' ||
            showModal === 'cw-contributor-delete-account'
              ? { width: 'max-content' }
              : {},
          ]"
          class="transform delay-100 inline-block rounded-lg p-12 sm:mt-8 sm:mb-20 sm:p-16 text-left shadow transition-all align-bottom sm:align-middle overflow-visible relative"
        >
          <SharedCentralLoginFormModal v-if="showModal === 'show-login'" />

          <SharedCentralPasswordResetModal
            v-if="showModal === 'show-central-reset'"
          />

          <ExpoCentralTermsOfUseModal v-if="showModal === 'exhibitor-terms'" />

          <ExpoCentralPrivacyPolicyModal v-if="showModal === 'expo-privacy'" />

          <CWCentralTermsOfUseModal v-if="showModal === 'terms'" />

          <CWTenantCloudStatsModal v-if="showModal === 'cloud-stats'" />

          <ExpoTenantPostPackModal
            v-if="showModal === 'expo-tenant-post-pack'"
          />

          <SharedTenantNewPostModal
            v-if="showModal === 'new-post'"
            :page="newPage"
          />

          <SharedIdleWarningModal v-if="showModal === 'IdleTimer'" />

          <SharedTenantFormLoginModal v-if="showModal === 'login'" />

          <div
            v-if="showModal === 'logout'"
            class="absolute z-50 top-0 left-0 right-0 bottom-0 flex flex-col justify-center items-center space-y-2"
          >
            <div class="h-32 w-32">
              <lottie :options="loadingAnimationOptions" />
            </div>
            <span class="text-lg font-bold text-white">Signing out...</span>
          </div>

          <FormResetPasswordModal
            v-if="showModal === 'reset-password'"
            :token="activeResetToken"
          />

          <span
            v-if="showModal === 'read-more'"
            class="prose"
            v-html="settings.profile_description"
          ></span>

          <CWTenantSubscribeMenuModal v-if="showModal === 'subscribe'" />

          <CWTenantMailSubscribeModal
            v-if="
              showModal === 'newsletter-subscribe' ||
              showModal === 'newsletter-unsubscribe'
            "
            :subscribe="showModal"
            :token="newsletterToken"
          />

          <CWTenantUpsertAdminModal
            v-if="showModal === 'cw-upsert-admin'"
            :config="modalData"
          />

          <FontPreviewModal v-if="showModal === 'font-preview'" />

          <SharedTenantFormContactModal v-if="showModal === 'contact'" />

          <CWFormRegisterConnectionParent
            v-if="showModal === 'cw-co-parent-registration'"
            :config="modalData"
          />

          <CWFormRegisterOrganisation
            v-if="showModal === 'cw-organisation-registration'"
            :config="modalData"
          />

          <CWSharedFormContactUsModal
            v-if="showModal === 'cw-registration'"
            :config="modalData"
          />

          <CWTenantTenantMailUpdateListModal
            v-if="showModal === 'cw-update-list'"
            :config="modalData"
          />
          <CWTenantUpdateSubscriberModal
            v-if="showModal === 'cw-update-subscriber'"
            :config="modalData"
          />
          <CWTenantMailDeleteConfirmationModal
            v-if="
              showModal === 'cw-delete-subscriber' ||
              showModal === 'cw-delete-list'
            "
            :config="modalData"
          />
          <CWTenantSubscriberStatsModal
            v-if="showModal === 'cw-stats-subscriber'"
            :config="modalData"
          />

          <CWTenantAutoNewsletterModal
            v-if="showModal === 'autoNewsletterModal'"
          />

          <CWTenantNewsletterPostsModal
            v-if="showModal === 'cw-newsletter-posts'"
            :config="modalData"
          />
          <CWTenantNewsletterStatsModal
            v-if="showModal === 'cw-newsletter-stats'"
            :config="modalData"
          />

          <CWTenantMigrationStatusModal
            v-if="showModal === 'cw-tenant-migration-status'"
          />

          <CWTenantEditorLinkModal
            v-if="showModal === 'editor-link-modal'"
            :config="modalData"
          />

          <CWTenantEditorWandInfoModal
            v-if="showModal === 'editor-wand-info-modal'"
          />

          <SharedPostDeleteModal
            v-if="showModal === 'post-delete'"
            :config="modalData"
          />

          <CWContributorSchoolsModal
            v-if="showModal === 'cw-contributor-schools'"
          />

          <CWContributorPostPackModal
            v-if="showModal === 'cw-contributor-post-pack'"
          />

          <CWContributorPostStatsModal
            v-if="showModal === 'cw-contributor-post-stats'"
            :config="modalData"
          />

          <CWContributorConnectionStatsModal
            v-if="showModal === 'cw-contributor-connection-stats'"
            :config="modalData"
          />

          <CWContributorInputDropdownSelector
            v-if="showModal === 'CWContributorInputDropdownSelector'"
            :config="modalData"
          />

          <CWContributorConnectionsPackModal
            v-if="showModal === 'cw-contributor-connections-pack'"
          />

          <CWContributorUpsertAccountModal
            v-if="showModal === 'cw-contributor-upsert-account'"
            :config="modalData"
          />

          <CWContributorDeleteAccountModal
            v-if="showModal === 'cw-contributor-delete-account'"
            :config="modalData"
          />

          <SharedConnectionsProfileModal
            v-if="showModal === 'connection-profile'"
            :config="modalData"
          />

          <SharedConnectionsInfoModal v-if="showModal === 'co-info-modal'" />

          <SharedCodeOfConductModal v-if="showModal === 'co-conduct-modal'" />

          <SharedConnectionsValidateModal
            v-if="showModal === 'cw-connections-verification'"
            :config="modalData"
          />

          <CWTenantAttachConnectionsModal
            v-if="showModal === 'attach-connections'"
            :config="modalData"
          />

          <CWTenantReportModal
            v-if="showModal === 'report-modal'"
            :config="modalData"
          />

          <CWTenantAddConnectionSuccessModal
            v-if="showModal === 'co-add-connection-success'"
          />

          <button
            v-if="showModal !== 'logout'"
            type="button"
            :class="[
              client === 'client1' ? 'hover:text-cw-alt' : '',
              client === 'client2' ? 'hover:text-expo_red' : '',
              client === 'client1tenant' || client === 'client2tenant'
                ? 'hover:text-primary'
                : '',
            ]"
            class="absolute right-4 top-4 lg:top-6 lg:right-4 transform hover:rotate-180 transition-all duration-300"
            @click="showModal = !showModal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!--  
      ************ 
      NESTED (SECONDARY) UNIVERSAL MODAL
      ************ 
    -->
    <div
      v-if="showModalNested"
      id="modalNested"
      class="fixed z-70 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <div
          :class="[
            'transform delay-100 inline-block rounded-lg p-12 sm:mt-8 sm:mb-20 sm:p-16 text-left shadow transition-all align-bottom sm:align-middle overflow-visible relative translate-y-0 bg-white',
          ]"
        >
          <component :is="showModalNested" :config="modalNestedData" />

          <!-- Close button -->
          <button
            type="button"
            :class="[
              client === 'client1' ? 'hover:text-cw-alt' : '',
              client === 'client2' ? 'hover:text-expo_red' : '',
              client === 'client1tenant' || client === 'client2tenant'
                ? 'hover:text-primary'
                : '',
            ]"
            class="absolute right-4 top-4 lg:top-6 lg:right-4 transform hover:rotate-180 transition-all duration-300"
            @click="toggleModalNested"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!--  
      ************ 
      UNIVERSAL Modal  
      ************ 
    -->

    <!-- 
      *************
      MANAGER RESOURCE MODAL 
      *************
    -->
    <SharedTenantMediaModal v-if="userAccess" />

    <!--
      ================================ 
      *** ARE WE  ON THE CLOUD : client === 'client1cloud' ???
      ================================ 
    -->
    <CWCloudFooter v-if="client === 'client1cloud'" />

    <!-- AlertToast -->
    <AlertToast />
  </div>
</template>

<script>
// Helpers and Util
import { websiteSettings } from '../../js/mixins/websiteSettings.js'
import { shared } from '../../js/mixins/shared.js'
import { EventBus } from '../../js/plugins/event-bus.js'
import { mapActions, mapGetters } from 'vuex'
import * as loadingAnimation from '../components/loading.json'
import AlertToast from '../components/AlertToast.vue'
import { parseURLParams } from '../../js/util/helper.js'
// CW //
// CW Central
import CWCentralTermsOfUseModal from '../../careerwise/central/components/TermsOfUseModal.vue'
import CWCentralMenu from '../../careerwise/central/components/Menu.vue'
import CWCentralFooter from '../../careerwise/central/components/Footer.vue'
// CW Contributor -- CD contributor dashboard
import CWCDMenu from '../../careerwise/contributor/components/Menu.vue'
// CW Central Shared
import CWFormRegisterConnectionParent from '../../careerwise/central/components/ModalRegisterConnectionParent.vue'
import CWFormRegisterOrganisation from '../../careerwise/central/components/ModalRegisterOrganisation.vue'
import CWSharedFormContactUsModal from '../../careerwise/shared/FormContactUs.vue'
// CW Tenant Public
import CWTenantFooter from '../../careerwise/tenant/public/components/Footer.vue'
import CWTenantMenuSmart from '../../careerwise/tenant/public/components/MenuSmart.vue'
import CWTenantLayout0Menu from '../../careerwise/tenant/public/pages/home/Layout0/Menu.vue'
import CWTenantLayout0MenuCompact from '../../careerwise/tenant/public/pages/home/Layout0/MenuCompact.vue'
import CWTenantLayout1Menu from '../../careerwise/tenant/public/pages/home/Layout1/Menu.vue'
import CWTenantLayout2Menu from '../../careerwise/tenant/public/pages/home/Layout2/Menu.vue'
import CWTenantLayout1MenuCompact from '../../careerwise/tenant/public/pages/home/Layout1/MenuCompact.vue'
import CWTenantMailSubscribeModal from '../../careerwise/tenant/public/components/MailSubscribeModal.vue'
import CWTenantSubscribeMenuModal from '../../careerwise/tenant/public/components/SubscribeMenuModal.vue'
// CW Tenant Manager
import FontPreviewModal from '../../careerwise/tenant/manager/pages/settings/FontPreviewModal.vue'
import CWTenantUpsertAdminModal from '../../careerwise/tenant/manager/pages/settings/ModalUpsertAdmin.vue'
import CWTenantCloudStatsModal from '../../careerwise/tenant/manager/pages/cloud/StatsModal.vue'
import CWTenantTenantMailUpdateListModal from '../../careerwise/tenant/manager/pages/mail/modal/UpdateListModal.vue'
import CWTenantUpdateSubscriberModal from '../../careerwise/tenant/manager/pages/mail/modal/UpdateSubscriberModal.vue'
import CWTenantMailDeleteConfirmationModal from '../../careerwise/tenant/manager/pages/mail/modal/DeleteConfirmationModal.vue'
import CWTenantNewsletterPostsModal from '../../careerwise/tenant/manager/pages/mail/modal/NewsletterPostsModal.vue'
import CWTenantNewsletterStatsModal from '../../careerwise/tenant/manager/pages/mail/modal/NewsletterStatsModal.vue'
import CWTenantSubscriberStatsModal from '../../careerwise/tenant/manager/pages/mail/modal/SubscriberStatsModal.vue'
import CWTenantAutoNewsletterModal from '../../careerwise/tenant/manager/pages/mail/modal/AutoNewsletterModal.vue'
import CWTenantMigrationStatusModal from '../../careerwise/tenant/manager/components/MigrationStatusModal.vue'
import CWTenantEditorLinkModal from '../../careerwise/tenant/manager/components/editor-wysiwyg/EditorLinkModal.vue'
import CWTenantEditorWandInfoModal from '../../careerwise/tenant/manager/components/editor-wysiwyg/EditorWandInfoModal.vue'
// CW Contributor Manager
import CWContributorSchoolsModal from '../../careerwise/contributor/components/modal/ModalSchoolsList.vue'
import CWContributorPostPackModal from '../../careerwise/contributor/components/modal/ModalPostPack.vue'
import CWContributorPostStatsModal from '../../careerwise/contributor/components/modal/ModalPostStats.vue'
import CWContributorConnectionStatsModal from '../../careerwise/contributor/components/modal/ModalConnectionStats.vue'
import CWContributorInputDropdownSelector from '../../careerwise/contributor/components/modal/ModalInputDropdownSelector.vue'
import CWContributorConnectionsPackModal from '../../careerwise/contributor/components/modal/ModalConnectionsPack.vue'
import CWContributorUpsertAccountModal from '../../careerwise/contributor/components/modal/ModalUpsertAccount.vue'
import CWContributorDeleteAccountModal from '../../careerwise/contributor/components/modal/ModalDeleteAccount.vue'
// CW Cloud
import CWCloudMenu from '../../careerwise/cloud/components/Menu.vue'
import CWCloudFooter from '../../careerwise/cloud/components/Footer.vue'
// Expo //
// Expo Tenant Public
import ExpoTenantMenu from '../../expo/tenant/public/Menu.vue'
import ExpoTenantMenuMobile from '../../expo/tenant/public/MenuMobile.vue'
import ExpoTenantFooter from '../../expo/tenant/public/Footer.vue'
import ExpoTenantPostPackModal from '../../expo/tenant/manager/ModalPostPack.vue'
// Expo Central
import ExpoCentralFooter from '../../expo/central/components/Footer.vue'
import ExpoCentralTermsOfUseModal from '../../expo/central/components/TermsOfUse.vue'
import ExpoCentralPrivacyPolicyModal from '../../expo/central/components/PrivacyPolicy.vue'
// Expo Shared
import ExpoGlobalMenu from '../../expo/GlobalMenu.vue'
import ExpoMainMenu from '../../expo/MainMenu.vue'
import ExpoMainMenuContent from '../../expo/MainMenuContent.vue'
// Shared //
import SharedPostDeleteModal from '../../shared/components/ModalPostDelete.vue'
// Shared Central
import SharedCentralLoginFormModal from '../central/FormLogin.vue'
import SharedCentralPasswordResetModal from '../central/FormPasswordReset.vue'
// Shared Tenant
import SharedTenantFormLoginModal from '../tenant/FormLoginModal.vue'
import FormResetPasswordModal from '../tenant/FormResetPasswordModal.vue'
import SharedTenantNewPostModal from '../tenant/NewPostModal.vue'
import SharedIdleWarningModal from '../tenant/IdleWarningModal.vue'
import SharedTenantFormContactModal from '../tenant/FormContactModal.vue'
import SharedTenantMediaModal from '../tenant/MediaModal.vue'
// Shared Connections
import CWTenantAttachConnectionsModal from '../../careerwise/shared/connections/components/modal/ModalAttachConnections.vue'
import CWTenantReportModal from '../../careerwise/shared/connections/components/modal/ModalReport.vue'
import CWTenantAddConnectionSuccessModal from '../../careerwise/shared/connections/components/modal/ModalAddConnectionSuccess.vue'
import SharedConnectionsProfileModal from '../../careerwise/shared/connections/components/modal/ModalProfile.vue'
import SharedConnectionsInfoModal from '../../careerwise/shared/connections/components/modal/ModalInfo.vue'
import SharedCodeOfConductModal from '../../careerwise/shared/connections/components/modal/ModalCodeOfConduct.vue'
import SharedConnectionsValidateModal from '../../careerwise/shared/connections/components/modal/ModalValidateConnection.vue'

export default {
  name: 'base-template',

  components: {
    SharedCentralLoginFormModal,
    SharedCentralPasswordResetModal,
    SharedPostDeleteModal,
    SharedTenantMediaModal,
    CWTenantMenuSmart,
    CWTenantLayout0Menu,
    CWTenantLayout0MenuCompact,
    CWTenantLayout1Menu,
    CWTenantLayout1MenuCompact,
    CWTenantLayout2Menu,
    CWTenantFooter,
    SharedTenantFormLoginModal,
    FormResetPasswordModal,
    AlertToast,
    CWCentralTermsOfUseModal,
    CWCloudMenu,
    CWCloudFooter,
    CWCDMenu,
    SharedTenantNewPostModal,
    SharedIdleWarningModal,
    CWTenantSubscribeMenuModal,
    SharedTenantFormContactModal,
    ExpoTenantMenu,
    ExpoTenantMenuMobile,
    ExpoTenantFooter,
    ExpoTenantPostPackModal,
    ExpoMainMenu,
    ExpoMainMenuContent,
    ExpoGlobalMenu,
    ExpoCentralFooter,
    ExpoCentralTermsOfUseModal,
    ExpoCentralPrivacyPolicyModal,
    CWCentralMenu,
    CWCentralFooter,
    // Central registration/enquiry forms
    CWFormRegisterConnectionParent,
    CWFormRegisterOrganisation,
    CWSharedFormContactUsModal,
    CWTenantTenantMailUpdateListModal,
    CWTenantUpdateSubscriberModal,
    CWTenantMailDeleteConfirmationModal,
    CWTenantNewsletterPostsModal,
    CWTenantNewsletterStatsModal,
    CWTenantSubscriberStatsModal,
    CWTenantAutoNewsletterModal,
    CWTenantMailSubscribeModal,
    FontPreviewModal,
    CWTenantUpsertAdminModal,
    CWTenantCloudStatsModal,
    CWTenantMigrationStatusModal,
    CWTenantEditorLinkModal,
    CWTenantEditorWandInfoModal,
    CWContributorSchoolsModal,
    CWContributorPostPackModal,
    CWContributorPostStatsModal,
    CWContributorConnectionStatsModal,
    CWContributorInputDropdownSelector,
    CWContributorConnectionsPackModal,
    CWContributorUpsertAccountModal,
    CWContributorDeleteAccountModal,
    SharedConnectionsProfileModal,
    CWTenantAttachConnectionsModal,
    CWTenantReportModal,
    CWTenantAddConnectionSuccessModal,
    SharedConnectionsInfoModal,
    SharedCodeOfConductModal,
    SharedConnectionsValidateModal,
  },

  mixins: [websiteSettings, shared],

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      modalData: null,
      showModal: false,
      showModalContents: false,
      showSmartMenu: false,
      activeResetToken: false,
      newsletterToken: false,

      modalNestedData: null,
      showModalNested: false,

      newPage: false,

      window: {
        width: 0,
        height: 0,
      },

      template: this.templateView,

      showExpoMenuContent: false,

      // @todo fix up tv_mode - just use vuex store TVMode
      tv_mode: false,
      tv_mode_scroll: false,
      tv_mode_speed: 15, // default is 30 seconds. Speed is half of this value
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      client: 'shared/getClient',
      user: 'shared/getUser',
      userAccess: 'shared/getUserAccess',
      templateView: 'shared/getTemplateView',
      idleTimer: 'shared/getIdleTimer',
      idleTimerClosed: 'shared/getIdleTimerClosed',
      customisation: 'careerwise/getCustomisation',
      TVMode: 'careerwise/getTVMode',
      isPortalContext: 'contributors/isPortalContext',
    }),

    baseContentClasses() {
      let classes = []

      if (
        this.template === 'Homepage' &&
        (this.client === 'client1tenant' || this.client === 'client2tenant')
      ) {
        classes.push('flex-nowrap')
      } else {
        classes.push('flex-wrap')
      }

      if (this.client === 'client1tenant' || this.client === 'client2tenant') {
        classes.push('flex', 'lg:mt-0')
      }

      if (this.userAccess) {
        classes.push('admin')
      }

      if (this.tv_mode) {
        classes.push('tvmode')
      }

      if (this.tv_mode_scroll) {
        classes.push('tvmode-scroll')
      }

      if (this.client === 'client1cloud') {
        classes.push('mt-16')
      }

      if (this.client === 'client1tenant') {
        classes.push('client1tenant')
      }

      if (this.client === 'client2tenant') {
        classes.push('client2tenant')
      }

      if (this.client === 'client1tenant') {
        if (this.customisation.layout === 0) {
          classes.push('layout-0')
        } else if (this.customisation.layout === 1) {
          classes.push('layout-1')
        } else if (this.customisation.layout === 2) {
          classes.push('layout-2')
        }

        if (this.customisation.menu === 0) {
          classes.push('menu-0')
        } else if (this.customisation.menu === 1) {
          classes.push('menu-1')
        }
      }

      return classes
    },
  },

  watch: {
    showExpoMenuContent: {
      handler: function (val) {
        EventBus.$emit('modal_state_changing', val)
      },

      deep: true,
    },

    showModal: {
      handler: function (active) {
        this.setBodyLockModal(active)
        if (!active) {
          this.$set(this, 'showModalContents', false)
          this.$set(this, 'newPage', false)
        } else {
          setTimeout(() => {
            this.$set(this, 'showModalContents', true)
          }, 100)
        }
      },

      deep: true,
    },

    templateView: {
      handler: function (template) {
        this.$set(this, 'template', template)
      },

      deep: true,
    },

    client: {
      handler: function () {
        EventBus.$emit('reloadWebsiteSettings')
      },

      deep: true,
    },

    $route: function () {
      const name = this.$router.history.current.name

      this.dispatchSetTemplateView(name)
      this.$set(this, 'template', name)

      if (name !== 'Post' || name !== 'Page') {
        // Clear the store for any "CURRENT" posts and resources if we are not on a post or page
        this.dispatchSetCurrentPost()
        this.dispatchSetCurrentPostResources()
        this.dispatchSetCurrentCloudPost()
      }
    },

    TVMode: {
      handler: function (val) {
        this.$set(this, 'tv_mode', val)
      },

      deep: true,
    },

    settings: {
      handler: function (val) {
        this.checkForTVMode()
        if (
          this.client === 'client1tenant' &&
          this.user &&
          val.migrations_status?.required
        ) {
          this.toggleModal('cw-tenant-migration-status')
        }
      },

      deep: true,
    },
  },

  mounted() {
    EventBus.$emit('reloadWebsiteSettings')
    // Set a dataset to the body tag indicating the browser's compatibility with this app
    this.checkBrowser()
    this.$set(this, 'tv_mode', this.TVMode)

    // SET THE TEMPLATE AND CLIENT ID
    this.dispatchSetTemplateView(this.$router.history.current.name)

    /**
                * **************************************************
                TOKEN HANDLELING
                * **************************************************
            */

    let subscribeToken = false
    let unsubscribeToken = false
    // let accessToken = false
    let resetToken = false
    let urlparams = parseURLParams(window.location.href)
    let login = false
    let resetlogin = false
    let terms = false

    Object.keys(urlparams).forEach((key) => {
      if (key === 'subscriber') {
        subscribeToken = urlparams[key][0]
      }
      if (key === 'unsubscribe') {
        unsubscribeToken = urlparams[key][0]
      }
      // if (key === 'signin') {
      //   accessToken = urlparams[key][0]
      // }
      if (key === 'reset-password') {
        resetToken = urlparams[key][0]
      }
      if (key === 'login') {
        login = true
      }
      if (key === 'resetlogin') {
        resetlogin = urlparams[key][0]
      }
      if (key === 'terms') {
        terms = true
      }

      if (key === 'verify-connection') {
        let id = urlparams.id ? urlparams.id[0] : null
        let token = urlparams.token ? urlparams.token[0] : null

        this.toggleModal({
          action: 'cw-connections-verification',
          data: {
            id: id,
            token: token,
          },
        })
      }

      if (key === 'add-connection') {
        this.toggleModal({
          action: 'co-add-connection-success',
        })
      }
    })

    if (login && (this.client === 'client1' || this.client === 'client2')) {
      // Dont allow on tenants!
      setTimeout(() => {
        this.toggleModal('show-login')
      }, 1000)
    }
    if (
      resetlogin &&
      (this.client === 'client1' || this.client === 'client2')
    ) {
      // Dont allow on tenants!
      setTimeout(() => {
        this.toggleModal('show-central-reset')
      }, 1000)
    }

    // ARE WE RESETTING PASSWORD
    if (resetToken) {
      this.$set(this, 'activeResetToken', resetToken)
      this.toggleModal('reset-password')
    }

    if (subscribeToken) {
      this.$set(this, 'newsletterToken', subscribeToken)
      this.toggleModal('newsletter-subscribe')
    }

    // ARE WE UN-SUBSCRIBING
    if (unsubscribeToken) {
      this.$set(this, 'newsletterToken', unsubscribeToken)
      this.toggleModal('newsletter-unsubscribe')
    }

    // DO WE NEED TO SHOW THE TERMS MODAL
    if (
      terms &&
      (this.client === 'client1' || this.client === 'client1tenant')
    ) {
      // Dont allow on expo!
      this.toggleModal('terms')
    }

    /** Universal Modal Activation */
    EventBus.$on('showModal', (contents) => {
      this.toggleModal(contents)
    })

    EventBus.$on('showModalNested', (contents) => {
      this.toggleModalNested(contents)
    })

    EventBus.$on('newPage', () => {
      this.$set(this, 'newPage', true)
      this.toggleModal('new-post')
    })

    EventBus.$on('newPageComplete', () => {
      this.$set(this, 'newPage', false)
    })

    EventBus.$on('toggleExpoMenuContent', () => {
      let active = !this.showExpoMenuContent
      this.$set(this, 'showExpoMenuContent', active)
    })

    // Modal being interacted with in nested component
    EventBus.$on('modal_state_changing', (active) => {
      this.setBodyLockModal(active)
    })

    EventBus.$on('showSmartMenu', (active) => {
      this.$set(this, 'showSmartMenu', active)
      if (this.showSmartMenu) {
        EventBus.$emit('modal_state_changing', true)
      }
      EventBus.$emit('smartMenuStateChanged', active)
    })

    EventBus.$on('openAdminMenu', () => {
      this.$set(this, 'showSmartMenu', true)
      {
        EventBus.$emit('modal_state_changing', true)
      }
      EventBus.$emit('smartMenuStateChanged', true)
    })

    //handle idle timer. If session has been running for 10 hours, reload application to avoid API access errors
    window.addEventListener('click', () => {
      if (this.client !== 'client1tenant' && this.client !== 'client2tenant') {
        return
      }
      let current = new Date()
      let dif = current.getTime() - this.idleTimer.getTime()
      let one_hour = 3600000
      //If already over 10, force refresh. If coming up to idle timer, give user an option
      if (dif > one_hour * 10) {
        window.location.reload()
      } else if (dif > one_hour * 9 && !this.idleTimerClosed) {
        EventBus.$emit('showModal', 'IdleTimer')
      }
    })

    // Check if tenant requires updates - websiteSettingsUpdated emitted from websiteSettings.js mixin.
    // This is called on mount and a good time to run an update query
    // @todo move to websiteSettings.js mixin to keep settings logic in one place
    // or better yet get rid of the mixin and just use vuex store actions to handle
    EventBus.$on('websiteSettingsUpdated', () => {
      if (this.client === 'client1tenant' && this.user) {
        this.checkForUpdates()
      }
    })

    // Check if tenant requires updates
    EventBus.$on('updateViewed', () => {
      if (this.client === 'client1tenant' && this.user) {
        this.checkForUpdates()
      }
    })

    EventBus.$on('posts_ready_for_tv_mode', () => {
      this.triggerTVMode()
    })
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    ...mapActions({
      dispatchSetTemplateView: 'shared/dispatchSetTemplateView',
      dispatchSetUserSettings: 'shared/dispatchSetUserSettings',
      dispatchSetCurrentPost: 'shared/dispatchSetCurrentPost',
      dispatchSetCurrentPostResources: 'shared/dispatchSetCurrentPostResources',
      dispatchCheckForUpdates: 'careerwise/dispatchCheckForUpdates',
      dispatchSetTVMode: 'careerwise/dispatchSetTVMode',
      dispatchSetCurrentCloudPost: 'careerwise/dispatchSetCurrentCloudPost',
    }),

    toggleModalNested(config) {
      if (config?.action) {
        this.$set(this, 'showModalNested', config.action)
        this.$set(this, 'modalNestedData', config.data)
      } else {
        this.$set(this, 'showModalNested', false)
        this.$set(this, 'modalNestedData', null)
      }
    },

    toggleModal(contents) {
      this.$set(this, 'showModal', false)
      if (!contents) {
        return
      }

      if (contents === 'logout') {
        setTimeout(() => {
          auth.signOut()
          this.$set(this, 'showModal', false)
          if (this.$router.currentRoute.name !== 'Home') {
            this.$router.push({ path: '/' })
          }
        }, 2000)
      } else if (contents.action) {
        // @todo use this `contents` structure globally
        // to remove dependent logic and magic no's
        this.$set(this, 'showModal', contents.action)
        this.$set(this, 'modalData', contents.data)
      } else {
        this.$set(this, 'showModal', contents)
      }
    },

    closeSubscriptionModal() {
      this.$set(this, 'showSubscribeModal', false)
    },

    closeUnSubscriptionModal() {
      this.$set(this, 'showUnSubscribeModal', false)
      this.$router.push({ path: '/' })
    },

    closeSubscriptionResponseModal() {
      this.$set(this, 'showSubscribeResponseModal', false)
      this.$set(this, 'subscribeResponseResult', false)
      this.$router.push({ path: '/' })
    },

    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },

    checkForUpdates() {
      this.dispatchCheckForUpdates()
    },

    // TV Mode
    checkForTVMode() {
      let tvmodetoken = false
      let scrolltoken = false
      let scrolltoken_exists = false
      let speedtoken = false
      let urlparams = parseURLParams(window.location.href)
      Object.keys(urlparams).forEach((key) => {
        if (key === 'tvmode') {
          tvmodetoken = urlparams[key][0]
        } else if (key === 'scroll') {
          scrolltoken = urlparams[key][0]
          scrolltoken_exists = true
        } else if (key === 'scrolltime') {
          speedtoken = urlparams[key][0]
        }
      })
      if (tvmodetoken && this.settings.plan === 3) {
        // Default scroll to true, only turning off if explicity set. This allows users who have already set up a scroll=true screen to have it honor that setting
        this.$set(this, 'tv_mode_scroll', true)
        if (scrolltoken_exists && scrolltoken === 'false') {
          this.$set(this, 'tv_mode_scroll', false)
        }

        if (speedtoken) {
          this.$set(this, 'tv_mode_speed', speedtoken)
        }

        this.dispatchSetTVMode(true)
      } else {
        this.dispatchSetTVMode(false)
      }
    },

    triggerTVMode() {
      //Triger the video element to be displayed, played, and then removed
      this.triggerTVModeVideo()

      //Set recurring video trigger
      setInterval(() => {
        this.triggerTVModeVideo()
      }, 60 * 1000)

      if (!this.tv_mode_scroll) {
        return
      }

      //Delay first scroll until after video has played
      setTimeout(() => {
        let contentArr = document.getElementsByClassName('tvmode')
        let content = contentArr[0]
        let contentHeight = content.offsetHeight + 300

        // set height of content for scrolling animation
        content.style.height = contentHeight * 2 + 'px'

        // Create the keyframes
        let keyframes = `
                        @keyframes scroll {
                            0% { transform: translateY(0); }
                            50% { transform: translateY(-${contentHeight}px); }
                            100% { transform: translateY(0); }
                        }
                    `

        let animationDuration = this.tv_mode_speed * 2 + 's'
        let animation = 'scroll ' + this.tv_mode_speed * 2 + 's linear infinite'

        // Apply the keyframes to the animation
        content.style.animationName = 'scroll'
        content.style.animationTimingFunction = 'linear'
        content.style.animationDuration = animationDuration
        content.style.animationIterationCount = 'infinite'
        content.style.animationFillMode = 'both'
        content.style.animation = animation

        // Create a new style tag
        let style = document.createElement('style')

        // Add the keyframes to the style tag
        style.innerHTML = `${keyframes}`

        // Append the style tag to the head
        document.head.appendChild(style)
      }, 6.5 * 1000)
    },

    triggerTVModeVideo() {
      let wrapper = document.getElementById('cwtv_video_wrapper')
      let video = document.getElementById('cwtv_video')
      wrapper.classList.add('active')
      if (!video || !wrapper) {
        return
      }
      video.play()
      setTimeout(() => {
        wrapper.classList.remove('active')
        video.load()
      }, 6000)
    },
  },
}
</script>

<style scoped>
.menu_homepage {
  height: calc(100vh - 3rem);
}

.cw_content {
  min-height: calc(100vh - 3rem);
  overflow: clip;
}

#cwtv_video_wrapper {
  opacity: 0;
}

#cwtv_video_wrapper.active {
  opacity: 1;
}

/* Customisation classes */
@media screen and (max-width: 1023px) {
  .client1tenant.layout-0 {
    margin-top: 4rem;
  }

  .client1tenant.layout-0.admin {
    margin-top: 5rem;
  }

  .client1tenant.layout-1 {
    margin-top: 5rem;
  }

  .client1tenant.tvmode {
    margin-top: 0;
    margin-left: 0;
    min-height: 100vh;
  }

  .client1tenant.tvmode.tvmode-scroll {
    height: 100vh;
    overflow: hidden;
  }
}

@media screen and (min-width: 1024px) {
  .client1tenant.layout-0.menu-0 {
    margin-left: 14rem;
  }

  .client1tenant.layout-0.menu-1 {
    margin-left: 4rem;
  }

  .client1tenant.layout-1 {
    margin-top: 5rem;
  }

  .client1tenant.tvmode {
    margin-top: 0;
    margin-left: 0 !important;
    min-height: 100vh;
  }

  .client1tenant.tvmode.tvmode-scroll {
    height: 100vh;
    overflow: hidden;
  }
}
</style>
